//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Components */
import { AIS_BASIC } from './index';
import { Loading, Snackbar } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
//#endregion

function AIS_BASICF() {
  useEffect(() => {
    Init();
  }, []);
  //#region 변수
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );

  // 조회일자
  const [dateValue, setDateValue] = useState({
    startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
  });

  // 검색창
  const searchRef = useRef({
    custList: custInfo.map((item) => ({
      value: item.CUST_CD,
      name: item.CUST_NM,
    })),
    //custCd: custInfo[0].CUST_CD,
    custCd: custInfo?.[0]?.CUST_CD ?? null,
    searchText: '',
  });

  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [changedRowData, setChangedRowData] = useState([]);
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    index: 0,
    actions: <></>,
  });
  const [inputs, setInputs] = useState({
    custCd: '', //사업장코드
  });
  const [custList, setCustList] = useState([]); //조회조건 사업장 목록
  const [modalToggle1, setModalToggle1] = React.useState(false); //그리드 안 현장 설정하기 팝업 창
  const [voiceUrl, setVoiceUrl] = useState(null); //그리드 안 이름 설정하기 id값 저장

  //#endregion
  const Init = async () => {
    SearchLogic1();
  };
  //#region 조회

  // 조회조건 사업장 조회()
  const SearchLogic1 = async () => {
    setLoading(true);
    setRowData([]);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GET_CUST_MANAGER',
            _userid: userInfo.userid,
          },
        ]
      ).then((result) => {
        let data = result.data;
        let changeData = [];
        if (data.length == 0) {
          setCustList([]);

          dispatch(
            showSnackbar({ message: '데이터가 없습니다.', type: 'info' })
          );
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(
            showSnackbar({
              message: data[0].message,
              type: 'error',
            })
          );

          return false;
        } else {
          data.forEach((_item) => {
            changeData.push({
              value: _item.custCd,
              name: _item.custNm,
            });
          });
          setCustList(changeData);
          setInputs({
            ...inputs,
            custCd: changeData[0].value,
          });
          SearchLogic2(
            changeData[0].value,
            dateValue.startDate,
            dateValue.endDate
          );
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //그리드 조회(_value1:사업장코드)
  const SearchLogic2 = async (_value1, _value2, _value3) => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_AIS_BASIC_R1',
            _CUST_CD: Commons.EncryptAES(_value1),
            _START_DATE: Commons.EncryptAES(_value2),
            _END_DATE: Commons.EncryptAES(_value3),
            _searchText: Commons.EncryptAES(searchRef.current.searchText) || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length == 0) {
          setRowData([]);
          dispatch(
            showSnackbar({
              message: '데이터가 없습니다.',
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(
            showSnackbar({
              message: data[0].message,
              type: 'error',
            })
          );
          return false;
        } else {
          setRowData(Commons.InsertNumber(data));
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // 녹음듣기
  const SearchLogic3 = async (_value1) => {
    setLoading(true);
    // console.log(_value1);

    // TEST
    // const voicePath = `AI_VOICE_LOG/2025051909500001/cw_s/202505190020_S.mp3`;

    // voiceAddress 사용 안할 시 사용
    // const voicePath = `AI_VOICE_LOG/${_value1.custCd}/${_value1.userId}/${_value1.voiceAddress}`;

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_value1.voiceAddress),
        }
      ).then((result) => {
        let data = result.data;

        if (data !== 'Error') {
          const mineType = 'audio/mpeg';
          const audioBlob = Base64ToBlob(data, mineType);
          const voiceUrl = URL.createObjectURL(audioBlob);

          setVoiceUrl(voiceUrl);
        }
        setModalToggle1(true);
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장
  //#endregion

  //#region 삭제
  //#endregion

  //#region 나머지 함수
  // Base64 -> Blob 변환 함수
  function Base64ToBlob(base64, mimeType) {
    const byteCharacters = atob(base64); // Base64 디코딩
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512);
      const byteNumbers = new Array(slice.length);
      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mimeType });
  }
  //#endregion

  return (
    <div className="wrap">
      <AIS_BASIC
        gridRef={gridRef}
        lanInfo={lanInfo}
        dateValue={dateValue}
        setDateValue={setDateValue}
        rowData={rowData}
        setRowData={setRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        searchRef={searchRef}
        SearchLogic1={SearchLogic1}
        SearchLogic2={SearchLogic2}
        SearchLogic3={SearchLogic3}
        dialog={dialog}
        setDialog={setDialog}
        inputs={inputs}
        setInputs={setInputs}
        custList={custList}
        setCustList={setCustList}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        setVoiceUrl={setVoiceUrl}
        voiceUrl={voiceUrl}
      />
      <Loading open={loading} />
    </div>
  );
}

export default AIS_BASICF;
